import { List, Typography } from "antd";
import { FC, useEffect, useRef } from "react";
import { styled } from "styled-components";

interface IProps {
  breakNames: string[];
  onSelectBreak(breakName: string): void;
  onTapOutside(): void;
}

const { Text } = Typography;

const BreakList: FC<IProps> = ({ breakNames, onSelectBreak, onTapOutside }) => {
  const listContainerRef = useRef<HTMLDivElement>(null);

  useEffect(
    () => {
      const handleTouchStart = (event: TouchEvent) => {
        if (listContainerRef.current && !listContainerRef.current.contains(event.target as Node))
          onTapOutside();
      };

      document.addEventListener("touchstart", handleTouchStart, true);
      return () => document.removeEventListener("touchstart", handleTouchStart, true);
    },
    [onTapOutside],
  );

  return (
    <ListContainer ref={listContainerRef}>
      <List
        size="large"
        dataSource={breakNames}
        renderItem={i => (
          <StyledListItem onClick={() => onSelectBreak(i)}>
            <Text>{getBreakDisplayName(i)}</Text>
          </StyledListItem>
        )}
      />
    </ListContainer>
  );
};

export default BreakList;

function getBreakDisplayName(breakName: string): string {
  return breakName.toLowerCase().endsWith("break") ? breakName : `${breakName} break`;
}

const ListContainer = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  max-height: 40%;
  width: 100%;
  background-color: ${p => p.theme.colorBgLayout};
  overflow-y: auto;
  border-radius: ${p => p.theme.borderRadiusLG * 2}px ${p => p.theme.borderRadiusLG * 2}px 0 0;

  transform: translateY(100%);
  animation: slideUp 0.12s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0%);
    }
  }
`;

const StyledListItem = styled(List.Item)`
  justify-content: center !important;

  & span.ant-typography {
      font-size: ${p => p.theme.fontSizeHeading5}px;
      text-align: center;
    }
`;
